/**
 * @NApiVersion 2.1
 * @NScriptType Suitelet
 */
define(["require", "exports", "N/record"], function (require, exports, record) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.onRequest = void 0;
    /**
     * @param {EntryPoints.Suitelet.onRequest} context
     */
    exports.onRequest = function (context) {
        if (context.request.method === 'GET') {
            var itemInternalId = context.request.parameters.internalid;
            var itemType = context.request.parameters.itemtype;
            var itemRecord = record.load({
                type: itemType,
                id: itemInternalId,
            });
            context.response.write(JSON.stringify({
                code: 200,
                outOfStockBehavior: itemRecord.getValue('outofstockbehavior'),
            }));
        }
    };
});
